export default function queryString(params, encode = false, append = false) {
    let queryString = '';
    let first = !append;
    for (var key in params) {
        if (params.hasOwnProperty((key)) && params[key]) {
            queryString += first ? '?' : '&';
            queryString += `${key}=${encode ? encodeURIComponent(params[key]) : params[key]}`;
            first = false;
        }
    }
    return queryString;
};



// WEBPACK FOOTER //
// ./app/lib/format/queryString.js